import "backboneAjaxQAdapter";

import Handlebars from 'handlebars';

import colors from '../../../../../libs/assets/colors.js';
import i18n  from "l10n";

export default Backbone.View.extend({
    tagName: 'div',
    className: '',
	data: null,
    initialize: function (options) {
        var self = this;

        this.data = options ? options.data : null;

	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		var self = this;
		this.superRender();

        this.createLineChart();

        return this;
	},
	events:{

    },
    createLineChart: function() {
        var self = this;
        var dataProvider = [];

        for(var i = 0; i<this.data.length; i++) {
            var tempModel = this.data[i].attributes;
            var tempObj = {
                "queue_name":  Handlebars.helpers.getQueueNameForLang(tempModel.queue),
                "maxWaitTime": tempModel.queuestatistic.maxWaitTime,
                "avgWaitTime": tempModel.queuestatistic.averageWaitTime
            };

            dataProvider.push(tempObj);

        }

        var chart = AmCharts.makeChart( "chartdiv", {
            "type": "serial",
            "addClassNames": true,
            "theme": "light",
            "autoMargins": true,
            "balloon": {
                "adjustBorderColor": false,
                "horizontalPadding": 10,
                "verticalPadding": 8
            },
            "legend": {
                "useGraphSettings": true,
                "markerSize":12,
                "valueWidth":0,
                "verticalGap":0
            },
            "dataProvider": dataProvider,
            "valueAxes": [ {
                "axisAlpha": 0.2,
                "position": "top",
                "dashLength" : 3,
                "minorGridEnabled": true,
                "minorGridAlpha": 0.08,
                "gridAlpha": 0.15
            } ],
            "startDuration": 1,
            "graphs": [
                {
                    "alphaField": "alpha",
                    "balloonText": "<span style='font-size:13px;'>[[title]] " + i18n.t("analytics.in_queue") + " [[category]]:<b> [[value]] "+ i18n.t('dashboard.minutes') + "</b></span>",
                    "title": i18n.t("analytics.max_time"),
                    "type": "column",
                    "valueField": "maxWaitTime",
                    "dashLengthField": "dashLengthColumn",
                    "fillColors" : colors.mustardYellow,
                    "lineAlpha" : 0,
                    "fillAlphas" : 0.8,
                    "fixedColumnWidth": 30,
                    "bulletBorderColor": colors.mustardYellow
                },
                {
                    "id": "graph2",
                    "type" : "line",
                    "lineColor" : colors.green,
                    "balloonText": "<span style='font-size:13px;'>[[title]] " + i18n.t("analytics.in_queue") + " [[category]]:<b> [[value]] "+ i18n.t('dashboard.minutes') + "</b></span>",
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": colors.green,
                    "bulletBorderColor": colors.green,
                    "bulletBorderThickness": 2,
                    "lineThickness": 2,
                    "fillAlphas": 0,
                    "title": i18n.t("analytics.avg_time"),
                    "valueField": "avgWaitTime"
                }
            ],
            "rotate": true,
            "categoryField": "queue_name",
            "categoryAxis": {
                "gridPosition": "start",
                "axisAlpha": 0,
                "tickLength": 0,
                "axisColor" : "#DADADA",
                "dashLength" : 3
            },
            "export": {
                "enabled": true
            }
        } );

        $("#chartdiv").css("height", (dataProvider.length * 45) + 'px');
    }
});


